import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AddressService } from "./service/address.service";
import { NgxsModule } from "@ngxs/store";
import { AddressState } from "./state/address.state";
import { ZipCodeService } from "./service/zipcode.service";

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([AddressState])],
  providers: [AddressService, ZipCodeService]})
export class AddressModule {}
